var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"px-8"},[_c('div',{staticClass:"w-full text-center py-4 px-16 rounded-md mt-2 small-p-text"},[_c('p',[_vm._v("© "+_vm._s(_vm.currentYear)+" Mpact International, Inc. All Rights Reserved.")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a30d17da","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/employer/includes/Footer.vue
// module id = null
// module chunks = 